<template>
	<div>
		<el-card>
			<el-form :inline="true" ref="form" :rules="rules" :model="form" class="demo-form-inline" style="" size="mini">
				<el-form-item label="问题" prop="question_title">
					<el-input v-model="form.question_title" placeholder="请输入常见问题" clearable></el-input>
				</el-form-item>
				<el-form-item label="回答" prop="question_content">
					<el-input v-model="form.question_content" placeholder="请输入问题答案" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="addQuestion">添加</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card style="margin-top: 10px;">
			<el-table :data="data.questions"  style="width: 100%;text-align: center;" size="mini">
				<el-table-column align="center" header-align="center" label="编号" width="100">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="question_title" label="问题">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="question_content" label="回答">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="admin_name" label="管理员" width="180">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="" label="删除" width="180">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="deleteQeustion(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;justify-content: flex-end; ">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
				 :page-sizes="[10, 20, 50, 100]" :page-size="formInline.limit" layout="total, sizes, prev, pager, next, jumper"
				 :total="data.total">
				</el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				rules: {
					question_title: [{
						required: true,
						message: '请输入问题',
						trigger: 'blur'
					}],
					question_content: [{
						required: true,
						message: '请输入答案',
						trigger: 'change'
					}]
				},
				form: {
					question_state: 1,
					question_title: '',
					question_content: ''
				},
				formInline: {
					page: 1,
					limit: 20
				},
				data: []
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			handleSizeChange(e) {
				this.formInline.limit = e;
				this.getData();
			},
			handleCurrentChange(e) {
				this.formInline.page = e;
				this.getData();
			},
			deleteQeustion(row) {
				var that = this;
				this.$confirm('确定要删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '考虑以下',
					type: 'warning'
				}).then(() => {
					that.$axios.post('zuche/question/deleteQeustion', {question_id:row.question_id}).then(function(res) {
						console.log(res);
						if (res.data.success) {
							that.getData();
						} else {
							that.$message.error(res.data.message);
						}
					});
				})
			},
			addQuestion() {
				console.log("方法进来了");
				var sub = true;
				var that = this;
				this.$refs['form'].validate((valid) => {
					sub = valid;
				});
				if (!sub) {
					return;
				}
				this.$axios.post('zuche/question/addQuestion', this.form).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.getData();
						that.form.question_title="";
						that.form.question_content="";
					} else {
						that.$message.error(res.data.message);
					}
				});
			},
			getData() {
				var that = this;
				this.$axios.post('zuche/question/getQuestionList', this.formInline).then(function(res) {
					if (res.data.success) {
						that.data = res.data.result;
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/changjianwenti.vue